import apiClient from '../client'

export const scanSessionsService = {
  // Create a new scan session
  createSession: async (payload) => {
    const response = await apiClient.post('/scan-sessions', payload)
    return response.data
  },

  // Get all scan sessions (with optional filters)
  getSessions: async (params = {}) => {
    const response = await apiClient.get('/scan-sessions', { params })
    return response.data
  },

  // Get a single scan session by ID
  getSessionById: async (id) => {
    const response = await apiClient.get(`/scan-sessions/${id}`)
    return response.data
  },

  // Trigger an immediate run of a session
  triggerRun: async (id) => {
    const response = await apiClient.post(`/scan-sessions/${id}/run`)
    return response.data
  },

  // Delete a scan session
  deleteSession: async (id) => {
    const response = await apiClient.delete(`/scan-sessions/${id}`)
    return response.data
  },
}
